import { render, staticRenderFns } from "./UserRoleRegister.vue?vue&type=template&id=11759176&scoped=true&"
import script from "./UserRoleRegister.vue?vue&type=script&lang=js&"
export * from "./UserRoleRegister.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleRegister.vue?vue&type=style&index=0&id=11759176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11759176",
  null
  
)

export default component.exports